// @ts-strict-ignore
import isEmpty from 'lodash/isEmpty';
import type { TFunction } from 'i18next';

import { actionTypes, itemType, serviceStatuses } from './constants';
import type { BlockedAction } from '../types';

type BlockedActionItem = {
  key: string;
  text: string;
};

export function generateBlockedActionsHash(
  blockedActions: BlockedAction[],
  summary: any,
  t: TFunction,
) {
  return blockedActions.reduce((acc, {
    blocking,
    blocked: {
      action_name: blockedActionName,
      action_type: actionType,
    },
    blocking: {
      action_name: blockingActionName,
      attribute_name: blockingAttributeName,
    } = {} as BlockedAction['blocking'],
  }: BlockedAction) => ({
    ...acc,
    ...(!isEmpty(blocking)
      ? ({
        blocked: [
          ...acc.blocked,
          ...(summary?.services?.[blockingActionName] === serviceStatuses.failed
            ? [{
              key: `blocked-${actionType}-${blockingActionName}`,
              text: t(
                `features.evaluations.results.partial.warnings.blocked_actions.${itemType.blocked}.${actionTypes.service}`,
                { blockedActionName: blockingActionName },
              ),
            }]
            : []
          ),
        ],
        blocking: [
          ...acc.blocking,
          {
            key: `blocking-${actionType}-${blockingActionName}`,
            text: t(
              `features.evaluations.results.partial.warnings.blocked_actions.${itemType.blocking}.${actionType}`,
              { blockedActionName, blockingActionName, blockingAttributeName },
            ),
          },
        ],
      })
      : ({
        blocked: [
          ...acc.blocked,
          {
            key: `blocked-${actionType}-${blockedActionName}`,
            text: t(
              `features.evaluations.results.partial.warnings.blocked_actions.${itemType.blocked}.${actionType}`,
              { blockedActionName },
            ),
          },
        ],
      })
    ),
  }),
  { blocked: [] as BlockedActionItem[], blocking: [] as BlockedActionItem[] });
}
